export default {"src":"/_next/static/media/plan-icon-2flower.bca9ffd2.svg","height":31,"width":30,"blurWidth":0,"blurHeight":0};